var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Loading...")])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v(_vm._s(_vm.broadcast.name))]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Broadcast " + _vm._s(_vm.uniqueId))])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right pill-right",
    attrs: {
      "type": "button",
      "variant": _vm.broadcast.approval == "denied" ? "outline-danger" : "danger",
      "disabled": _vm.broadcast.approval == "denied"
    },
    on: {
      "click": _vm.onDeny
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("  Deny")]), _c('b-btn', {
    staticClass: "pull-right pill-left",
    attrs: {
      "type": "button",
      "variant": _vm.broadcast.approval == "approved" ? "outline-success" : "success",
      "disabled": _vm.broadcast.approval == "approved"
    },
    on: {
      "click": _vm.onApprove
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Approve")])], 1)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Audience:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.audience))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Message:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.message))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Campaign Link:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("https://m.me/" + _vm._s(_vm.botName) + "/?" + _vm._s(_vm.lowerName))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Start Date:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.start_date))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("End Date:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.end_date))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Platforms:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-row', [_c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Email"),
      expression: "\"Email\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    class: {
      "text-success": _vm.broadcast.email
    }
  })]), _c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("SMS"),
      expression: "\"SMS\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile",
    class: {
      "text-success": _vm.broadcast.sms
    }
  })]), _c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Facebook Messenger"),
      expression: "\"Facebook Messenger\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    class: {
      "text-success": _vm.broadcast.messenger
    }
  })])], 1)], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93bd158a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Campaign.vue
// module id = 925
// module chunks = 1